<template>
  <div :style="`height:${height}px`">
    <h2>
      Credits
    </h2>
  </div>
</template>

<script>
import Player from "@/components/common/player";
export default {
  name: "AboutIntro_Credits",
  components: {
    Player
  },
  props: {
    resource: {
      type: Object,
      default: () => {}
    },
    height: {
      type: Number,
      default: 300
    }
  },
  computed: {},
  methods: {},
  data() {
    return {};
  }
};
</script>
<style lang="scss" scoped></style>
